import firebase from 'firebase'
var firebaseConfig = {
  apiKey: 'AIzaSyD7OES2DdE6LlCW0W5oyvsjo0S9XxguoxE',
  authDomain: 'tabletennis-2b21d.firebaseapp.com',
  databaseURL: 'https://tabletennis-2b21d-default-rtdb.europe-west1.firebasedatabase.app',
  projectId: 'tabletennis-2b21d',
  storageBucket: 'tabletennis-2b21d.appspot.com',
  messagingSenderId: '579814191419',
  appId: '1:579814191419:web:a13dbe035bfdd42aeac71e',
  measurementId: 'G-R7MDHBCCSX',
  };

  
  
const firebaseApp=firebase.initializeApp(firebaseConfig);
const db=firebase.firestore();

export default db;